import { Button } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import { useReservationPaymentUrl } from "./hooks/useReservationPaymentUrl";
import { GuestPublicContext } from "../types/GuestPublicContext";

export function FinalizeBookingPayButton({
  reservation,
}: {
  reservation: Pick<GuestPublicContext, "reservationId">;
}) {
  const { t } = useTranslation();
  const { data, loading } = useReservationPaymentUrl(reservation.reservationId);

  return (
    <Button
      as="a"
      href={data?.url || ""}
      isLoading={loading}
      variation="primary"
      isFullWidth={true}
      size="large"
    >
      {t("FinalizeBooking.Submit")}
    </Button>
  );
}
